import PressRelease from "./PressReleaseSingle";

export default PressRelease;